
import { mapGetters } from 'vuex'

import DynamicContainer from '../DynamicContainer/DynamicContainer.vue'
import FixedContainer from '../FixedContainer/FixedContainer.vue'

import { TYPES } from './ProductBlock.constant'

export default {
  components: {
    DynamicContainer,
    FixedContainer,
  },

  props: {
    offers: {
      type: Object,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    pickers: {
      type: Array,
      default: () => [],
    },

    ratings: {
      type: Object,
      required: true,
    },

    swapOffer: {
      type: Object,
      default: () => ({}),
    },

    swapListings: {
      type: Array,
      default: () => [],
    },

    swapStatus: {
      type: String,
      required: true,
    },

    technicalSpecifications: {
      type: Object,
      required: true,
    },

    trackingInfo: {
      type: Object,
      default: () => ({}),
    },

    shouldDisplayEcoBlock: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
    }),

    reassurance() {
      return this.offers.activeGrade.reassurance || {}
    },

    carouselImages() {
      return this.product.images
    },

    mainProductImage() {
      return this.carouselImages[0]
    },

    page() {
      let type = ''

      switch (this.product.type) {
        case TYPES.REFURBISHED:
          type = TYPES.REFURBISHED
          break

        case TYPES.ACCESSORY:
          type = TYPES.ACCESSORY
          break

        default:
          type = TYPES.REFURBISHED
          break
      }

      return {
        type,
      }
    },

    modelTitle() {
      return this.product.title
    },

    modelSubtitles() {
      return this.product.subTitleElements
    },

    isRebrandingExperimentActive() {
      return this.experiments.headerSoftRebranding === 'white'
    },
  },
}
